import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Form, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import RowLoader from "../../Components/UI/RowLoader";
import "flatpickr/dist/themes/material_blue.css";
import DropdownForm from "../Form/DropdownForm";
import {
  getActivationReasons,
  getPartnerActivationStatus,
  updatePartnerActivationStatus,
} from "../../apis";

const AdminAccountStatusControl = () => {
  const [reasonsData, setReasonsData] = useState([]);
  const [currentPartnerActivationStatus, setCurrentPartnerActivationStatus] =
    useState({});
  const { id } = useParams();

  const initialValues = {
    status: currentPartnerActivationStatus?.value === 0 ? 1 : 0,
    reason_id: "",
    note: "",
  };

  const validationSchema = Yup.object().shape({
    status: Yup.string().required("Required"),
    reason_id: Yup.string().required("Required"),
  });

  useEffect(() => {
    getPartnerActivationStatus(id)
      .then((response) => {
        const isActive = response.data.data === "Active" ? 1 : 0;
        setCurrentPartnerActivationStatus({
          value: isActive,
          label: response.data.data,
        });
        getActivationReasons(isActive)
          .then((response) => {
            setReasonsData(response.data.data);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);

    updatePartnerActivationStatus(id, values)
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Partner status has been updated successfully!",
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while updating the partner status.",
        });
      })
      .finally(() => {
        setSubmitting(false);
      });

    console.log(values);
  };
  const updatedStatus =
    currentPartnerActivationStatus?.value === 0
      ? [{ label: "Active", value: "1" }]
      : [{ label: "Not Active", value: "0" }];

  return (
    <div className="card !tw-rounded-lg tw-overflow-hidden">
      <div className="card-header !tw-bg-primary tw-text-white d-flex tw-flex-col sm:tw-flex-row tw-gap-2 align-items-center justify-content-between">
        <div className="tw-w-full md:tw-w-fit">
          <h5 className="card-title mb-0">Update Activation Status</h5>
        </div>
        <div className="tw-w-full md:tw-w-fit">
          <h5 className="card-title mb-0 sm:tw-text-end">
            <span>Current Status : </span>{" "}
            {currentPartnerActivationStatus?.label ?? ""}
          </h5>
        </div>
      </div>
      <div className="card-body">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({
            errors,
            touched,
            values,
            setFieldValue,
            handleChange,
            isSubmitting,
          }) => (
            <Form className="d-flex flex-column">
              <div className="row">
                <DropdownForm
                  dataToDrop={updatedStatus}
                  handleChange={handleChange}
                  label={"Updated Status"}
                  name={"status"}
                  placeholder={"Updated Status"}
                  touched={touched.status}
                  required
                  error={errors.status}
                  labelKey="label"
                  valueKey="value"
                />

                <DropdownForm
                  dataToDrop={reasonsData ?? []}
                  handleChange={handleChange}
                  label={"Reason"}
                  name={"reason_id"}
                  placeholder={"Reason"}
                  touched={touched.reason_id}
                  required
                  error={errors.reason_id}
                  labelKey="reason"
                  valueKey="id"
                />

                <div className="col-md-6 mb-3">
                  <label className="form-label" htmlFor="note">
                    note
                  </label>
                  <textarea
                    type="text"
                    name="note"
                    className="form-control"
                    rows="4"
                    value={values.note}
                    onChange={(e) => {
                      setFieldValue("note", e.target.value);
                    }}
                  />
                  <ErrorMessage
                    name="note"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-primary ml-auto mt-5 !tw-w-[100px]"
              >
                {isSubmitting ? <RowLoader paddingStyle="tw-py-0" /> : "Submit"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AdminAccountStatusControl;
